'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CatalogDetailMock = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _delay = require('./delay');

var _delay2 = _interopRequireDefault(_delay);

var _mockData = require('./mockData');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogDetailMock = exports.CatalogDetailMock = {
    fetchCatalogDetailsByIds: function fetchCatalogDetailsByIds(catalogIds) {
        return new _promise2.default(function (resolve) {
            setTimeout(function () {
                var catalogTerms = catalogIds.map(function (x) {
                    return (0, _mockData.getTestCatalogDetails)(x);
                });
                resolve({
                    data: {
                        data: catalogTerms
                    }
                });
            }, _delay2.default);
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/mock/catalogDetail.js
// module id = hmCE
// module chunks = 46